export const version = '1.0.1.48';
export const buildInfo = {
    date: '10.09.24',
    time: '09:09'
};
